export const EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR = {
	TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
	TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed',
} as const;

export const ExportJiraContextToPageTourKeys = [
	...Object.values(EXPORT_JIRA_CONTEXT_TO_PAGE_TOUR),
] as const;
